module.exports = __webpack_public_path__ + "static/media/gift-list3-active.2adc23fa.png";